// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__3uANy","vatRate":"styles_vatRate__L4XrS","vatRateLabel":"styles_vatRateLabel__0h23j","slideInSearchBar":"styles_slideInSearchBar__6z08J"};